
global.jQuery = require('jquery');
require('foundation-sites');

// If you want to pick and choose which modules to include, comment out the above and uncomment
// the line below
import './lib/foundation-explicit-pieces';
jQuery(document).foundation();
